// UI strings for the grade buttons' explainer (study/GradesIntro.tsx): shown once before a person's
// first card (Axel's decision of 2026-10-06) and again from the "?" beside the grades. Each line
// matches what the grade does (lib/fsrs.ts, StudySession: a learning step under 15 min comes back
// in the same session; the button shows the real interval). The names are `grades.names` (fi.ts).
import { defineArea } from '../area';

export const gradesIntroFi = {
  title: 'Kuinka hyvin muistit?',
  lead: 'Kun vastaus näkyy, valitse yksi neljästä:',
  /** One short line per grade, after its name. */
  lines: {
    1: 'et muistanut: kortti tulee takaisin vielä tässä harjoituksessa',
    2: 'muistit vaivalla: kortti palaa pian',
    3: 'muistit: kortti palaa myöhemmin',
    4: 'tiesit heti: kortti palaa paljon myöhemmin',
  } as Record<1 | 2 | 3 | 4, string>,
  foot: 'Painikkeessa lukee, milloin kortti palaa.',
  ok: 'Selvä',
  /** The "?" beside the grades (its accessible name and tooltip). */
  help: 'Mitä arviot tarkoittavat?',
};

export const gradesIntroEn: typeof gradesIntroFi = {
  title: 'How well did you remember?',
  lead: 'Once the answer shows, pick one of four:',
  lines: {
    1: "you didn't remember: the card comes back in this session",
    2: 'you remembered with effort: it returns soon',
    3: 'you remembered: it returns later',
    4: 'you knew it at once: it returns much later',
  },
  foot: 'Each button shows when the card returns.',
  ok: 'Got it',
  help: 'What do the grades mean?',
};

// Messages.gradesIntro (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('gradesIntro', gradesIntroFi, gradesIntroEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof gradesIntroFi> {}
}
